/* Guest feedback and review invitations (docs/API.md §18 → Enums). */
export enum FeedbackKind {
    Praise     = 'praise',
    Complaint  = 'complaint',
    /** A guest's suggestion for improvement — no stars, as a complaint. */
    Suggestion = 'suggestion',
}

export const FEEDBACK_KINDS: FeedbackKind[] = [FeedbackKind.Complaint, FeedbackKind.Suggestion, FeedbackKind.Praise]

export enum FeedbackCategory {
    Room        = 'room',
    Cleanliness = 'cleanliness',
    Food        = 'food',
    Staff       = 'staff',
    Noise       = 'noise',
    WifiTv      = 'wifi_tv',
    Other       = 'other',
}

export const FEEDBACK_CATEGORIES: FeedbackCategory[] = [
    FeedbackCategory.Room, FeedbackCategory.Cleanliness, FeedbackCategory.Food, FeedbackCategory.Staff,
    FeedbackCategory.Noise, FeedbackCategory.WifiTv, FeedbackCategory.Other,
]

export enum FeedbackStatus {
    New        = 'new',
    InProgress = 'in_progress',
    Resolved   = 'resolved',
}

export const FEEDBACK_STATUSES: FeedbackStatus[] = [FeedbackStatus.New, FeedbackStatus.InProgress, FeedbackStatus.Resolved]

/** The room TV's ready sentences (§18.2); their texts are the clients' (§18.3). */
export const FEEDBACK_PRESETS: string[] = [
    'room_comfortable', 'room_spotless', 'food_delicious', 'staff_friendly', 'quiet_room', 'wifi_fast', 'would_return',
    'room_temperature', 'room_not_clean', 'food_slow', 'staff_waiting', 'noise_night', 'wifi_slow', 'tv_not_working', 'something_broken',
    'breakfast_choice', 'coffee_in_room', 'towels_on_request', 'soundproofing', 'more_channels', 'local_tips', 'eco_friendly',
]

export enum ReviewSite {
    Google      = 'google',
    Tripadvisor = 'tripadvisor',
    Booking     = 'booking',
    Facebook    = 'facebook',
    Instagram   = 'instagram',
}

export const REVIEW_SITES: ReviewSite[] = [ReviewSite.Google, ReviewSite.Tripadvisor, ReviewSite.Booking, ReviewSite.Facebook, ReviewSite.Instagram]

/** When the guest is invited to review the hotel (§18.5). */
export enum ReviewInvite {
    AfterFeedback = 'after_feedback',
    DepartureDay  = 'departure_day',
    AfterCheckout = 'after_checkout',
}

export const REVIEW_INVITES: ReviewInvite[] = [ReviewInvite.AfterFeedback, ReviewInvite.DepartureDay, ReviewInvite.AfterCheckout]

/** Where a review link was opened from (§18.5). */
export enum ReviewSource {
    Tv       = 'tv',
    Phone    = 'phone',
    Checkout = 'checkout',
}

/** The overview's and the list's window, in days (§18.4: 1–400). */
export const FEEDBACK_DAYS: number[] = [7, 30, 90, 365]

/** The span of one point of the summary's trend (§18.4). */
export enum FeedbackTrendBucket {
    Day   = 'day',
    Week  = 'week',
    Month = 'month',
}
